<template>
  <div :style="style"></div>
</template>

<script>
  import * as echarts from 'echarts'
  export default {
    name: 'ChartView',
    data() {
      return {
        myChart: null
      }
    },
    props: {
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '350px'
      },
      display: {
        type: String,
        default: 'block'
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      chartOption: {
        type: Object,
        require: true
      },
      picType: {
        type: String,
        default: 'canvas'
      },
      reRender: {
        type: Boolean,
        default: false
      },
      mapJson: {
        type: Object
      }
    },
    computed: {
      style() {
        return {
          width: this.width,
          height: this.height,
          display: this.display
        }
      }
    },
    watch: {
      chartOption: {
        deep: true,
        handler(newOption) {
          this.setOptions(newOption)
        }
      }
    },
    mounted() {
      this.initChart()
      if (this.autoResize) {
        window.addEventListener('resize', this.resizeHandler)
      }
    },
    beforeDestroy() {
      // console.log("I am destoried")
      if (!this.myChart) {
        return
      }
      if (this.autoResize) {
        window.removeEventListener('resize', this.resizeHandler)
      }
      this.myChart.dispose()
      this.myChart = null
    },
    methods: {
      initChart() {
        this.myChart = echarts.init(this.$el, {
          renderer: this.picType
        })
        if (this.mapJson) {
          echarts.registerMap('mapObject', this.mapJson)
        }
        this.myChart.setOption(this.chartOption)
        // 绑定鼠标事件
        // this.chart.on('click', this.handleClick)
      },
      resizeHandler() {
        // setTimeout for height changing event
        setTimeout(
          this.myChart.resize({
            animation: {
              duration: 300
            }
          }),100
        )
      },
      // handleClick(params) {
      //   this.$emit('click', params)
      // },
      setOptions(option) {
        // 决定是否要完全重新渲染图片
        this.myChart.hideLoading()
        if (this.reRender){
          // console.log('refresh')
          this.clearChart()
        }
        //this.resizeHandler()
        if (this.myChart) {
          // console.log(this.myChart)
          this.myChart.setOption(option, true)
        }
      },
      refresh() {
        this.setOptions(this.chartOption)
      },
      clearChart() {
        this.myChart && this.myChart.clear()
      }
    }
  }
</script>

<style>

</style>